import React from 'react';
import PropTypes from 'prop-types';

const Strings = require('../../../../app/shared/Strings');
import AccessibleIcon from '../common/AccessibleIcon';

const propTypes = {
    className: PropTypes.string,
};
const defaultProps = {
    className: '',
};


function WelcomePrompt(props) {
    const LINK_D = 'https://discord.gg/YKSPK26naw';
    const LINK_RO = 'https://www.muzzylane.com/demo';
    const externalLinkIcon = (
        <AccessibleIcon
            className="fa fa-external-link"
            label={Strings['en'].common.OPEN_NEW_TAB}
        />
    );
    return (
        <div className={'welcomePrompt ' + props.className}>
            <div className="welcomePrompt__text">
                <p className="welcomePrompt__prompt">
                    {Strings['en'].dashboard.WELCOME_PROMPT}
                </p>
                <ul>
                    <li>
                        {Strings['en'].dashboard.DISCORD_LINK}: <a href={LINK_D} target="_blank">{LINK_D} {externalLinkIcon}</a>
                    </li>
                    <li>
                        {Strings['en'].dashboard.REACH_OUT_LINK}: <a href={LINK_RO} target="_blank">{LINK_RO} {externalLinkIcon}</a>
                    </li>
                </ul>
            </div>
        </div>    
    );
}

WelcomePrompt.propTypes = propTypes;
WelcomePrompt.defaultProps = defaultProps;

export default WelcomePrompt;
